export default __webpack_public_path__ + "static/media/thumb.87af08c0.svg";